<template>
  <div>
    <header class="header">
      <div class="header__top-wrapper">
        <div class="header__content">
          <drop-down v-cloak class="--country mr-3" @showDrop="showDrop">
            <template v-slot:dropdown__wrapper>
              <div class="dropdown__wrapper">
                <input type="text" class="search-string"/>
                <span class="dropdown__current">{{ $store.state.language }}</span>
              </div>
            </template>
            <!-- 使用 "header" 插槽 -->
            <template v-slot:drop-down-item>
              <drop-down-item  class="dropdown__list" style="display: none;" v-show="showDropF">
                <template v-slot:li>
                  <li v-for="(region, code) in $t('i18n.regions')" :key="code" @click="changeRegion(region)">
                    <span>{{ region }}</span>
                  </li>
                </template>
              </drop-down-item>
            </template>
          </drop-down>
        </div>
        <div class="header__content ml-auto">
          <ul class="header__content">
            <li class="header__content-li" v-for="(item, index) in headerTopLeftMenus" :key="index">
              <div @click="toPage(item.path, item)" class="header__content-a" :class=" {'active': item.showActive}">{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="header__wrapper">
        <drop-down v-cloak class="--country mr-3 langBox" @showDrop="showDrop" v-if="isMobile()">
            <template v-slot:dropdown__wrapper>
              <div class="dropdown__wrapper">
                <input type="text" class="search-string"/>
                <span class="dropdown__current">{{ $store.state.language }}</span>
              </div>
            </template>
            <!-- 使用 "header" 插槽 -->
            <template v-slot:drop-down-item>
              <drop-down-item  class="dropdown__list" style="display: none;" v-show="showDropF">
                <template v-slot:li>
                  <li v-for="(region, code) in $t('i18n.regions')" :key="code" @click="changeRegion(region)">
                    <span>{{ region }}</span>
                  </li>
                </template>
              </drop-down-item>
            </template>
          </drop-down>
        <router-link to="/" class="header__logo"></router-link>
        
        <nav class="header__main-nav" v-show="!showSearch">
          <ul class="header__main-nav-ul">
            <li class="header__main-nav-li" ref="mainNav" v-hover="{ className: '--hover' }"  :class="item.showDownArrow ? '--sub' :  ''" v-for="(item, index) in headerBottomLeftMenus" :key="index" @click.stop="(e) => showDropDown(e, item, index)">
              <div class="header__main-nav-a" @click="toPage(item.path, item)" :class=" {'active': item.showActive}">{{ item.showSearch ? '' : $t('i18n.headerMain.' + item.name) }}</div>
              <ul class="header__main-drop-down" v-if="item.children">
                <li v-for="(child, index) in item.children" :key="index" @click.stop="(e) => showChildren(e, child, index, item)" ref="headerDropDown">
                  <span class="header__main-drop-down-span" :class="{ '--down': child.showChild }">{{ $t('i18n.headerMainChildren.' + child.name) }}</span>
                  <ul v-if="child.children" v-show="child.showChild">
                    <li v-for="(son, sonIndex) in child.children" :key="sonIndex" class="header__main-drop-down-span-son" :ref="`span-spn${sonIndex}`" @click.stop="handleClick(son, item)">
                      <span class="header__main-drop-down-span-son-span" >{{ $t('i18n.headerMainChildren.' + son.name) }}</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div class="header__search" :class="{ 'ml-auto': showSearch }">
          <div class="header__search-loupe" :class="{ '--close': showSearch }" @click="showSearch = !showSearch"></div>
          <div class="header__hamburger" @click="showM"></div>
          <div class="header__searchbar" v-show="showSearch">
            <div class="header__searchbar-wrapper">
              <button class="header__search-btn" @click="search"></button>
              <!--  @keydown="search" -->
              <input type="text" class="header__searchbar-input" :placeholder="$t('i18n.search')" v-model="form.keyword">
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import DropDown from "./DropDown";
import DropDownItem from "./DropDownItem";
import {homeSearch} from "../api/api.js";
export default {
  name: "Header",
  components: {DropDownItem, DropDown},
  data() {
    return {
      currentLang: 'zh',
      selectedRegion: "中文",
      showDropF: false,
      showSearch: false,
      showDropMobile: false,
      headerTopLeftMenus: [],
      headerBottomLeftMenus: [
        {
          name: "news",
          path: "News",
          showDownArrow: false,
          showDropDown: false,
          showActive: false,
        },
        {
          name: "vacuumValve",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "MGVAGV",
              path: "VacuumValve1",
              isLast: true,
              showChild: false,
              pathImg: require('../assets/imgs/MGVAGV.png'),
              img: require('../assets/imgs/MGAVGimg.png'),
              technicalImg: require('../assets/imgs/MGVAGVTechnical.png'),
              downloadImg: require('../assets/imgs/MGVAGVDownloadImg.png'),
              propertiesName: "MGVAGVpro",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "butterflyValve",
              path: "VacuumValve2",
              isLast: true,
              showChild: false,
              pathImg: require('../assets/imgs/butterfly.png'),
              img: require('../assets/imgs/butterflyImg.png'),
              technicalImg: require('../assets/imgs/butterflyTechnical.png'),
              downloadImg: require('../assets/imgs/butterfluDownloadImg.png'),
              propertiesName: "butterflyPro",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "cornerValve",
              showChild: false,
              children: [
                {
                  name: "highVacuumDirectValve",
                  path: "VacuumValve3",
                  isLast: true,
                  pathImg: require('../assets/imgs/corner.png'),
                  img: require('../assets/imgs/corenrImgTwo.png'),
                  technicalImg: require('../assets/imgs/corenrTechnicalOne.png'),
                  downloadImg: require('../assets/imgs/corenrDownloadOne.png'),
                  propertiesName: "highVacuumDirectValve",
                  showFlg: true,
                  type: "PDF",
                  size: "4 MB"
                },
                {
                  name: "UHV",
                  path: "VacuumValve4",
                  isLast: true,
                  pathImg: require('../assets/imgs/corner.png'),
                  img: require('../assets/imgs/corenrImg.png'),
                  technicalImg: require('../assets/imgs/corenrTechnicalTwo.png'),
                  downloadImg: require('../assets/imgs/corenrDownloadTwo.png'),
                  propertiesName: "UHV",
                  showFlg: true,
                  type: "PDF",
                  size: "4 MB"
                },
              ]
            },
            {
              name: "rectangularValve",
              path: "VacuumValve5",
              showChild: false,
              isLast: true,

              pathImg: require('../assets/imgs/rectangularValve.png'),
              img: require('../assets/imgs/rectangularValveImg.png'),
              technicalImg: require('../assets/imgs/rectangularValveTechnical.png'),
              downloadImg: require('../assets/imgs/rectangularValveDownload.png'),
              propertiesName: "rectangularValve",
              showFlg: false,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "gate",
              showChild: false,
              children: [
                {
                  name: "highVacuumGateValve",
                  path: "VacuumValve6",
                  isLast: true,

                  pathImg: require('../assets/imgs/highVacuum.png'),
                  img: require('../assets/imgs/highVacuumImg.png'),
                  technicalImg: require('../assets/imgs/highVacuumTechnical.png'),
                  downloadImg: require('../assets/imgs/highVacuumDownload.png'),
                  propertiesName: "highVacuumGateValve",
                  showFlg: true,
                  type: "PDF",
                  size: "4 MB"
                },
                {
                  name: "vacuumGateValve",
                  path: "VacuumValve7",
                  isLast: true,

                  pathImg: require('../assets/imgs/vacuum.png'),
                  img: require('../assets/imgs/vacuumImg.png'),
                  technicalImg: require('../assets/imgs/vacuumTechnical.png'),
                  downloadImg: require('../assets/imgs/vacuumDownload.png'),
                  propertiesName: "vacuumGateValve",
                  showFlg: true,
                  type: "PDF",
                  size: "4 MB"
                },
              ]
            },
            {
              name: "combinedValve",
              path: "VacuumValve8",
              isLast: false,


              pathImg: require('../assets/imgs/combinedValve.png'),
              img: require('../assets/imgs/combinedValveImg.png'),
              technicalImg: require('../assets/imgs/combinedValveTechnical.png'),
              downloadImg: require('../assets/imgs/combinedValveDownload.png'),
              propertiesName: "combinedValve",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
          ],
          path: "VacuumValveMain",
          showActive: false,
        },
        {
          name: "presys",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "presys",
              path: "Presys",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "presysBriefIntroduction",
              path: "PresysBriefIntroduction",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "presysCourse",
              path: "PresysProcess",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
          ],
          path: "Presys",
          showActive: false,
        },
        {
          name: "productService",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "valveRepairDndMaintenance",
              path: "valveRepairDndMaintenance",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "upgradeDndTransformation",
              path: "upgradeDndTransformation",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "serviceCenter",
              path: "serviceCenter",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
          ],
          path: "valveRepairDndMaintenance",
          showActive: false,
        },
        /*{
          name: "otherProducts",
          showDownArrow: false,
          showDropDown: false,
          // children: [
            // {
            //   name: "Genius",
            //   showChild: false,
            //   children: [
            //     {
            //       name: "throttleValve",
            //       path: "throttleValve",
            //       isLast: true,
            //       showChild: false,
            //       showFlg: true,
            //     },
            //     {
            //       name: "throttleValveController",
            //       path: "throttleValveController",
            //       isLast: true,
            //       showChild: false,
            //       showFlg: true,
            //     },
            //     {
            //       name: "dualThrottleValve",
            //       path: "dualThrottleValve",
            //       isLast: true,
            //       showChild: false,
            //       showFlg: true,
            //     },
            //     {
            //       name: "multiPositionController",
            //       path: "multiPositionController",
            //       isLast: true,
            //       showChild: false,
            //       showFlg: true,
            //     },
            //   ]
            // },
            // {
            //   name: "MNE",
            //   path: "MNE",
            //   isLast: true,
            //   showChild: false,
            //   showFlg: true,
            // },
            // {
            //   name: "UNISEMChiller",
            //   path: "UNISEMChiller",
            //   isLast: true,
            //   showChild: false,
            //   showFlg: true,
            // },
          // ],
          path: "throttleValve",
         showActive: false,
        },*/
       ],
      form: {},
    }
  },
  created() {

  },
  watch:{
    $route(to,from){
      if (to.path === '/home') {
        console.log(to.path);
        this.headerBottomLeftMenus.forEach(item => {
          item.showActive = false;
        })
      }
    }
  },
  mounted() {
    // this.currentIndex = sessionStorage.getItem("pagePath") || 1;
    this.currentLang = sessionStorage.getItem("language") || 'zh';
    if (this.currentLang == 'zh') {
      this.$store.commit('saveLanguage', '中文')
      this.$i18n.locale = "zh";
      this.headerTopLeftMenus = [
        {
          name: "关于佳晟",
          path: "about",
        },
        {
          name: "工作机会",
          path: "CareerOpportunities",
        },
        {
          name: "下载",
          path: "/download",
        },
        {
          name: "佳晟荣誉",
          path: "/honor",
        },
        {
          name: "联系我们",
          path: "contactUs",
        },
      ]
    } else {
      this.$i18n.locale = "en";
      this.$store.commit('saveLanguage', 'English')
      this.headerTopLeftMenus = [
        {
          name: "About",
          path: "about",
        },
        {
          name: "Job",
          path: "CareerOpportunities",
        },
        {
          name: "download",
          path: "/download",
        },
        {
          name: "Honors",
          path: "/honor",
        },
        {
          name: "contactUs",
          path: "contactUs",
        },
      ]
    }
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    search() {
      if (!this.form.keyword) {
        return;
      }
      homeSearch(this.form).then(res => {
        if (res && res.data && res.data.data) {
          this.goPageSwitch(res.data.data.title);
        }

      })
    },
    goPageSwitch(val) {
      switch (val) {
        // case "MGV/AGV":
        case "手动/自动真空闸阀":
          this.$router.push('VacuumValve1')
          break;
        case "蝶形控制阀":
        this.$router.push('VacuumValve2')
          break;
        case "高真空直通阀":
          this.$router.push('VacuumValve3')
          break;
        case "UHV角阀":
          this.$router.push('VacuumValve4')
          break;
        case "矩形阀":
          this.$router.push('VacuumValve5')
          break;
        case "高真空闸阀":
          this.$router.push('VacuumValve6')
          break;
        case "真空闸阀":
          this.$router.push('VacuumValve7')
          break;
        case "蝶阀和隔离阀":
          this.$router.push('VacuumValve8')
          break;
        case "TRANSFER DOOR VALVE SERIES V77":
          this.$router.push({
            name: 'presysDetail',
          
            params: { form: this.$t('i18n.presysHomeList')[0] }
          })
          break;
        case "TRANSFER VALVE L-MOTION, SERIES V74":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[1] }
          })
          break;
        case "TRANSFER VALVE L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[2] }
          })
          break;
        case "NON-STANDARD DOUBLE OPENING L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[3] }
          })
          break;
        case "NON-STANDARD FOUR OPENING L-MOTION, SERIES V70":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[4] }
          })
          break;
        case "ALL HEATING TRANSFER VALVE L-MOTION, SERIES V72":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[5] }
          })
          break;
        case "DOUBLE LAYER L-MOTION, SERIES V73":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[6] }
          })
          break;
        case "TRANSFER VALVE I-MOTION, SERIES V78":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[7] }
          })
          break;
        case "VACUUM GATE VALVE, SERIES V20":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[8] }
          })
          break;
        case "HV GATE VALVE, SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[9] }
          })
          break;
        case "UHV GATE VALVE/3-POSITION, SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[10] }
          })
          break;
        case "WITH HEAT JACKET,SERIES V21":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[11] }
          })
          break;
        case "HV PROTECTION GATE VALVE, SERIES V60":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[12] }
          })
          break;
        case "REMOTE PLASMA CONTROL VALVE , SERIES V41":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[13] }
          })
          break;
        case "LARGE TRANSFER VALVE/DOOR L-MOTION, SERIES V75":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[14] }
          })
          break;
        case "LARGE TRANSFER VALVE/INSERT T-MOTION, SERIES V76":
          this.$router.push({
            name: 'presysDetail',
            params: { form: this.$t('i18n.presysHomeList')[15] }
          })
          break;
        case "Throttle Valve":
          this.$router.push("throttleValve")
          break;
        case "Throttle Valve Controller":
          this.$router.push("throttleValveController")
          break;
        case "Dual Throttle Valve":
          this.$router.push("dualThrottleValve")
          break;
        case "Multi Position Controller":
          this.$router.push("multiPositionController")
          break;
        case "MNE 密封圈O-RING":
          this.$router.push("MNE")
          break;
        case "UNISEM chiller温控装置":
          this.$router.push("UNISEMChiller")
          break;
      }
    },
    showDropDown(e, item, index) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      this.$router.push({
        name: item.path,
      })
    },
    showChildren(e, item, index, father) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      if (father.name === "vacuumValve" || father.name === "otherProducts") {
        if (!item.path && item.children) {
          item.showChild = !item.showChild;
        } else if (item.path) {
          father.showDropDown = false;
          this.$router.push(item.path)
          father.showActive = true;
        }
      } else {
        father.showDropDown = false;
        this.$router.push(item.path)
        father.showActive = true;
      }
      this.headerBottomLeftMenus.forEach(temp => {
        if (temp.name !== father.name) {
          temp.showActive = false;
        }
      })
      this.headerTopLeftMenus.forEach(temp => {
        if (temp.name !== item.name) {
          temp.showActive = false;
        }
      })
      this.$forceUpdate();
    },
    handleClick(item, father) {
      if ("/" + item.path === this.$route.path) {
        return;
      }

      father.showActive = true;
      this.headerBottomLeftMenus.forEach(temp => {
        if (temp.name !== father.name) {
          temp.showActive = false;
        }
      })
      this.headerTopLeftMenus.forEach(temp => {
        if (temp.name !== item.name) {
          temp.showActive = false;
        }
      })
      this.$forceUpdate();

      father.showDropDown = false;
      this.$router.push(item.path)
    },
    toPage(path, item) {
      if (path) {
        this.$router.push(path)
        item.showActive = true;
        this.headerBottomLeftMenus.forEach(temp => {
          if (temp.name !== item.name) {
            temp.showActive = false;
          }
        })
        this.headerTopLeftMenus.forEach(temp => {
          if (temp.name !== item.name) {
            temp.showActive = false;
          }
        })
        this.$forceUpdate();
      }
      if (item) {
        this.showDropMobile = false;
      }
    },
    showDrop() {
      this.showDropF = !this.showDropF;
    },
    changeRegion(region) {
      sessionStorage.setItem("language", region === "中文" ? 'zh' : 'en');
      this.$store.commit('saveLanguage', region)
      this.$i18n.locale = region === "中文" ? 'zh' : 'en';
      this.$router.go(0);
    },
    showChildrenMobile(item) {
      item.showDropDown = !item.showDropDown
    },
    showM() {
      this.$emit("showM")
    },
    changePage (index) {
      this.$emit('changePage',index)
    }
  },
}
</script>

<style scoped>
.header {
  width: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background: #fff;
  transition-property: all;
  transition-duration: .6s;
}
.header__top-wrapper {
  height: 5rem;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  border-bottom: 0.1rem solid #ededed;
  font-size: 1.6rem;
  color: #7f7f7f;
}

.header__content {
  display: flex;
}
.dropdown__list {
  width: 100%;
  min-width: 17rem;
  max-height: 17rem;
  min-height: 4rem;
  overflow: auto;
  background: #fff;
  position: absolute;
  border: .1rem solid #e6e6e6;
  top: 100%;
  margin-top: .2rem;
  z-index: 200;
  border-radius: .4rem;
  box-shadow: 0 2rem 4rem 0 rgba(0,0,0,.1);
}
.dropdown__list::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  border-radius: 0.4rem;
}
.dropdown__list ul li:hover span {
  color: #909;
}

.dropdown__list ul li span {
  cursor: pointer;
}
.dropdown__list ul li a, .dropdown__list ul li span {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}

.header__content {
  display: flex;
}
ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.header__content-li {
  margin: 0 2rem;
  display: flex;
  align-items: center;
}

.header__wrapper {
  height: 10rem;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  position: relative;
}

.header__logo {
  width: 24rem;
  min-width: 12.72rem;
  height: 8rem;
  margin-right: 4rem;
  background: url(../assets/imgs/logo.png) no-repeat 50%;
  background-size: 100% auto;
}
a {
  text-decoration: none;
  transition-property: all;
  transition-duration: .3s;
}

.header__main-nav {
  margin-left: auto;
  height: 100%;
}

.header__main-nav-ul {
  display: flex;
  height: 100%;
}

.header__main-nav-li {
  position: relative;
  height: 100%;
}

.header__main-nav-a {
  font-size: 1.8rem;
  color: #000;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding: 0 3rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 100%;
}

.header__main-nav-li.--sub .header__main-nav-a:after {
  content: "";
  width: 0.8rem;
  height: 0.6rem;
  background: url(../assets/imgs/downArrowTow.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  top: 50%;
  margin-top: -0.3rem;
}

.header__main-nav-li.--search .header__main-nav-a:after {
  content: "";
  width: 3.5rem;
  height: 3.5rem;
  background: url(../assets/imgs/searchImg.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  top: 35%;
  margin-top: -0.3rem;
}
.header__main-nav-a {
  cursor: pointer;
}
.header__content-a:hover {
  cursor: pointer;
  color: #990099;
}
.header__main-nav-a:hover {
  color: #990099;
}
.dropdown .dropdown__wrapper:before {
  background: #80ba27;
}
.dropdown .dropdown__wrapper:before {
  content: "";
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -.8rem;
  background: #ccc;
  -webkit-mask: url(../assets/imgs/world.svg) no-repeat center;
  mask: url(../assets/imgs/world.svg) no-repeat center;
  transition: all .2s ease-in-out;
}
.dropdown .dropdown__wrapper:after, .dropdown.--visible.--text .dropdown__wrapper:after {
  right: 0;
}
.dropdown .dropdown__wrapper:after {
  background: lightgray;
}
.dropdown__wrapper:after {
  content: "";
  width: .8rem;
  height: .6rem;
  -webkit-mask: url(../assets/imgs/downArrow.png) no-repeat center;
  mask: url(../assets/imgs/downArrow.png) no-repeat center;
  position: absolute;
  right: 2rem;
  top: 50%;
  margin-top: -.3rem;
  transition-property: background;
  transition-duration: .3s;
}
.header__main-drop-down {
  display: none;
}
.header__main-nav-li.--hover .header__main-drop-down {
  display: block !important;
  width: 25rem;
  min-width: 17rem;
  max-height: 26rem;
  min-height: 6rem;
  overflow: auto;
  background: #fff;
  position: absolute;
  border: .1rem solid #e6e6e6;
  top: 100%;
  /*margin-top: .2rem;*/
  z-index: 200;
  border-radius: .4rem;
  box-shadow: 0 2rem 4rem 0 rgba(0,0,0,.1);

}
.header__main-nav-li.--hover .header__main-drop-down::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  border-radius: 0.4rem;
}
.header__main-nav-li.--hover .header__main-drop-down .header__main-drop-down-span {
  cursor: pointer;
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.2rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son .header__main-drop-down-span-son-span {
  cursor: pointer;
  width: 100%;
  min-height: 4rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.2rem;
  line-height: 1rem;
}

.header__main-nav-li.--hover .header__main-drop-down-span.--down:after {
  transform: rotate(90deg);
}
.header__main-nav-li.--hover .header__main-drop-down-span:after {
  content: "";
  width: 1rem;
  height: 1rem;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  position: absolute;
  right: 2rem;
  margin-top: -.3rem;
  background-color: #66207F;
  transition-property: background;
  transition-duration: .3s;
}
.header__main-nav-li.--hover .header__main-drop-down-span:hover {
  color: #66207F;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son-span:hover {
  color: #66207F;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son-span:after {
  content: "";
  width: 1rem;
  height: 1rem;
  -webkit-mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  mask: url(../assets/imgs/arrow-right.png) no-repeat center;
  position: absolute;
  right: 2rem;
  margin-top: -.3rem;
  background-color: #66207F;
  transition-property: background;
  transition-duration: .3s;
}

.header__search-loupe {
  margin-left: 2.4rem;
  width: 3.8rem;
  height: 3.8rem;
  cursor: pointer;
  background: #66207F;
  -webkit-mask: url(../assets/imgs/searchImg.png) no-repeat center;
  mask: url(../assets/imgs/searchImg.png) no-repeat center;
  transition-property: background-color;
  transition-duration: .3s;
}
.header__hamburger {
  width: 6rem;
  height: 6rem;
  cursor: pointer;
  display: none;
  -webkit-mask: url(../assets/imgs/hamburger.svg) no-repeat center;
  mask: url(../assets/imgs/hamburger.svg) no-repeat center;
  background-color: #5A246B;
}
.header__searchbar {
  position: absolute;
  left: 42.5rem;
  right: 21.5rem;
  top: 50%;
  margin-top: -3.5rem;
  height: 7rem;
  width: 50%;
}
.header__search-btn {
  width: 6.6rem;
  height: 7rem;
  cursor: pointer;
  position: absolute;
  right: 2.5rem;
  top: 0;
  padding: 0;
  background: #b2b2b2;
  -webkit-mask: url(../assets/imgs/searchImg.png) no-repeat center;
  mask: url(../assets/imgs/searchImg.png) no-repeat center;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition: all .2s ease-in-out;
}
.form-input, input[type=email], input[type=text] {
  width: 100%;
  height: 6rem;
  padding: 0 2.5rem;
  font-size: 1.8rem;
  color: #000;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition-property: all;
  transition-duration: .3s;
}
.header__searchbar-input {
  width: 100%;
  height: 7rem!important;
  padding: 0 3rem;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  font-size: 1.8rem;
  color: #4c4c4c;
  letter-spacing: 0;
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* .header__searchbar-input:focus {

} */
.header__search-loupe.--close {
  mask: url(../assets/imgs/close.svg) no-repeat center;
}


.header__main-nav-mobile {
  position: fixed;
  z-index: 99999;
  left: 0;
  width: 100%;
  height: calc(100% - 11rem);
  overflow: auto;
  background: #fff;
}
.header__main-nav-mobile .header__main-nav-ul {
  display: block;
  height: auto;
  width: 100%;
  padding: 1rem 0;
  background: #fafafa;
}

.header__submenu-overflow {
  overflow: auto;
  max-height: calc(100vh - 15rem);
  background: #fff;
}
.header__submenu-wrapper {
  border: 0;
  height: auto;
  padding: 1rem 0;
  max-height: 100%;
  overflow: visible;
}
.header__submenu-list.--only-mobile {
  display: none;
  padding: 0 3rem;
}
.header__main-nav-mobile .header__main-nav-a {
  font-size: 2rem;
  height: 6rem;
  padding: 1rem 3rem !important;
  min-height: 4rem;
  margin: 0;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div {
  font-size: 2rem;
  padding: 1rem 3rem !important;
  height: 4rem;
  display: block;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div:after {
  content: "";
  width: 1rem;
  height: 1rem;
  background: url(../assets/imgs/select-arrow.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  margin-top: -0.3rem;
}
.header__links-mobile {
  padding: 0 3rem 1.5rem;
  background: #fafafa;
}
.header__links-mobile .header__content {
  padding-top: 3rem;
  border-top: .1rem solid #e6e6e6;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.header__links-mobile .header__content .header__content-li {
  min-width: 50%;
  max-width: 50%;
  margin: 0 0 1.5rem;
}
.header__lang-mobile {
  background: #fff;
  padding: 3rem;
  display: flex;
  justify-content: center;
}
.active {
  color: #990099;
}
@media (max-width: 1279.9px) {
  .header__main-nav-li.--sub .header__main-nav-a:after {
    width: 3rem;
    height: 3rem;
    top: 2rem;
  }
  .header__logo {
    width: 15rem;
    min-width: 9.4rem;
    height: 3.1rem;
    margin-right: 3rem;
    margin-top: 4rem;
  }
  .header__wrapper {
    padding: 0 3rem;
  }
  .header__search-loupe {
    margin-left: 1.2rem;
    margin-right: 3rem;
  }
  .header__main-nav-li:before {
    left: 1.5rem;
    right: 1.5rem;
  }
}

@media (max-width: 1024px) {
  .header__submenu-list.--only-mobile {
    display: block;
  }
  .header__searchbar {
    top: 12rem;
    margin-top: 0;
    border-top: .1rem solid #ededed;
    left: 0;
    right: 0;
    padding: 3rem;
    background: #fff;
    height: auto;
  }
  .header__searchbar-wrapper {
    position: relative;
  }
  .header__hamburger {
    display: flex;
  }
  .header__wrapper {
    height: 11rem;
    padding: 0 1.5rem 0 3rem;
  }
  .header__main-nav {
    display: none;
  }
  .header__top-wrapper {
    display: none !important;
  }
  .header__search {
    margin-left: auto;
    display: flex;
    margin-top: 5rem;
  }
  .header__search-loupe {
    width: 5rem;
    height: 5rem;
  }
}

@media (max-width: 768px) {
  .langBox {
    position: absolute !important;
    top: 10px;
    left: 3rem;
  }

  .header__wrapper {
    height: 110px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue